// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page__container[data-v-2903f43d]{margin-left:auto;margin-right:auto;max-width:1400px;padding-left:15px;padding-right:15px;position:relative}.error-page__number[data-v-2903f43d]{font-size:60px;margin-bottom:20px}.error-page__text[data-v-2903f43d]{font-size:20px}.error-page__link[data-v-2903f43d]{margin-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
